
    <template>
    <svg width="36" height="36" viewBox="0 0 36 36" xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor"
        d="M11.448 21.6v3.84h12V21.6H36V36H0V21.6h11.448zM26.4 28.464h-4.8v4.8h4.8v-4.8zm7.2 0h-4.8v4.8h4.8v-4.8zM17.448 0l1.56 1.704 5.808 6.384 2.904 3.168h-6.672v11.712h-7.2V11.256H7.176l2.904-3.168 5.808-6.384L17.448 0z" />
</svg>
    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'UploadFile',
    }) as DefineComponent
    </script>
    